import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { formatErr } from "../lib/api";
import Navbar from "../components/Navbar";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      const u = await login(email, password);
      toast.success("Bentornato/a!");
      if (!u.onboarded) nav("/onboarding"); else nav("/dashboard");
    } catch (ex) {
      setErr(formatErr(ex.response?.data?.detail) || "Errore");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#F9F8F6]">
      <Navbar />
      <div className="max-w-md mx-auto px-6 py-16">
        <h1 className="font-serif-display text-4xl text-[#1E3F33]">Accedi</h1>
        <p className="mt-2 text-[#6B6B6B]">Riprendi il monitoraggio della tua IVA.</p>
        <form onSubmit={submit} className="mt-8 card-flat p-6 space-y-4">
          <div>
            <label className="label-caps block mb-2">Email</label>
            <input data-testid="login-email" type="email" required value={email} onChange={e=>setEmail(e.target.value)}
              className="w-full px-3 py-2 border border-[#EBE5DF] rounded-md bg-white focus:outline-none focus:border-[#1E3F33]"/>
          </div>
          <div>
            <label className="label-caps block mb-2">Password</label>
            <input data-testid="login-password" type="password" required value={password} onChange={e=>setPassword(e.target.value)}
              className="w-full px-3 py-2 border border-[#EBE5DF] rounded-md bg-white focus:outline-none focus:border-[#1E3F33]"/>
          </div>
          {err && <div data-testid="login-error" className="text-sm text-[#A83C22]">{err}</div>}
          <button data-testid="login-submit" disabled={loading} className="btn-lift w-full py-3 bg-[#1E3F33] text-white rounded-md hover:bg-[#152D24] disabled:opacity-60">
            {loading ? "Accesso in corso…" : "Entra"}
          </button>
          <div className="text-right">
            <Link to="/password-dimenticata" data-testid="link-forgot" className="text-xs text-[#6B6B6B] hover:text-[#1E3F33] underline">Password dimenticata?</Link>
          </div>
        </form>
        <p className="mt-6 text-sm text-[#6B6B6B]">
          Non hai un account? <Link to="/registrati" data-testid="link-register" className="text-[#1E3F33] underline">Registrati</Link>
        </p>
      </div>
    </div>
  );
}
